// ディレクターコレクションのお気に入りボタン。
// customer.metafields.custom.favorite_collections (単一行テキストのリスト) にコレクションの
// handle を追加/削除する Admin API 連携の App Proxy エンドポイントを使う:
//   POST /apps/favorite-collections/api/toggle  body: { handle, favorited: true | false }
//   -> 200 OK  body: { favorited: true | false }（処理後のサーバーの状態）
//
// 楽観的UI: クリックで即座に表示を切り替え、最後のクリックから SYNC_DELAY_MS 後に
// 「ユーザーが最後に望んだ状態 (desired)」を送る。同時に送るリクエストは1件だけで、
// 通信中に押された分は通信完了後にまとめて送る。
document.addEventListener('DOMContentLoaded', function () {
  const SYNC_DELAY_MS = 300;
  const ERROR_MESSAGE = 'お気に入りの更新に失敗しました。時間をおいて再度お試しください。';
  const buttons = document.querySelectorAll('[data-favorite-director-button]');

  buttons.forEach(function (button) {
    const handle = button.dataset.collectionHandle;
    const initial = button.classList.contains('exist');
    const state = {
      confirmed: initial, // サーバーで確定している状態
      desired: initial, // ユーザーが望んでいる状態（＝画面の表示）
      inFlight: false,
      timer: null,
    };

    button.addEventListener('click', function () {
      const isLoggedIn = button.dataset.customerLoggedIn === 'true';
      if (!isLoggedIn) {
        const modal = document.getElementById('not-login-favorite-modal');
        if (modal) {
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
        return;
      }

      hideError(button);
      state.desired = !state.desired;
      setFavoritedState(button, state.desired, { animate: true });

      clearTimeout(state.timer);
      state.timer = setTimeout(function () {
        state.timer = null;
        sync();
      }, SYNC_DELAY_MS);
    });

    function sync() {
      // 最新の操作が失敗した場合は desired = confirmed に戻すので、ここで止まり無限ループしない
      if (state.inFlight || state.desired === state.confirmed) {
        return;
      }

      state.inFlight = true;
      const target = state.desired;

      fetch('/apps/favorite-collections/api/toggle', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ handle: handle, favorited: target }),
        // 通信中にページを離れてもリクエストを中断させない
        keepalive: true,
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Failed to update favorite collection');
          }
          return response.json();
        })
        .then(function (data) {
          // 通信中に押されていた場合に最新の操作を消さないよう、表示は上書きしない
          state.confirmed = data.favorited === true;
        })
        .catch(function () {
          // 送ったあとにまた押されていた場合は、次の送信で最新の状態を送るので表示は戻さない
          if (state.desired === target) {
            state.desired = state.confirmed;
            setFavoritedState(button, state.confirmed);
            showError(button);
          }
        })
        .finally(function () {
          state.inFlight = false;
          // 通信中に押された分を送る。デバウンス待ち中ならそのタイマーに任せる
          if (state.desired !== state.confirmed && state.timer === null) {
            sync();
          }
        });
    }
  });

  function setFavoritedState(button, favorited, options) {
    options = options || {};
    button.classList.toggle('exist', favorited);
    button.classList.toggle('not-exist', !favorited);
    button.setAttribute('aria-pressed', String(favorited));

    if (options.animate && favorited) {
      button.classList.add('animate-favorite-add');
      setTimeout(function () {
        button.classList.remove('animate-favorite-add');
      }, 400);
    }
  }

  function showError(button) {
    let message = button.parentNode.querySelector('.favorite-director__error');
    if (!message) {
      message = document.createElement('p');
      message.classList.add('favorite-director__error');
      message.setAttribute('role', 'alert');
      button.insertAdjacentElement('afterend', message);
    }
    message.innerText = ERROR_MESSAGE;
    message.hidden = false;
  }

  function hideError(button) {
    const message = button.parentNode.querySelector('.favorite-director__error');
    if (message) {
      message.hidden = true;
    }
  }
});
